<template>
  <div class="tw-bg-white tw-w-auto tw-h-auto tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-4 tw-max-w-96 tw-shadow-2xl tw-rounded-xl">
    <div class="tw-py-8 tw-text-center">
      <div class="tw-relative">
        <img
          :src="url as string"
          alt="QR Code"
          class="tw-w-64 tw-h-64"
          :class="{
            'tw-hidden': isLoading,
          }"
          @load="handleLoad" />
        <div
          v-if="hideQR"
          class="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-75 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
          role="button"
          @click="getImage">
          <font-awesome-icon
            icon="refresh"
            class="tw-text-primary-700 tw-text-9xl tw-text-white" />
        </div>
      </div>
      <div
        class="tw-h-64 tw-w-64 tw-flex tw-flex-row tw-items-center tw-justify-center"
        :class="{
          'tw-hidden': !isLoading,
        }">
        <font-awesome-icon
          icon="spinner"
          class="tw-animate-spin tw-text-primary-700 tw-text-3xl" />
      </div>
    </div>
    <div
      v-if="countDown && !hideQR && !isLoading"
      class="tw-text-center tw-text-semibold tw-text-xs"
      v-html="t('rc.message_qr_code_validity')"></div>
    <CountDown
      v-if="countDown && !hideQR && !isLoading"
      :totalSeconds="countDown"
      @end="handleEnd" />
    <BaseButton
      v-else
      @click="getImage"
      :text="t('platform.button_refresh')"></BaseButton>
  </div>
</template>
<script setup lang="ts">
import { useGlobalConfigsStore } from "@/storeModules/globalConfigs/globalConfigs";
import { onMounted, ref } from "vue";
import axios, { AxiosRequestConfig } from "axios";
import CountDown from "./CountDown.vue";
import BaseButton from "../../BaseButton/BaseButton.vue";
import { useTranslation } from "i18next-vue";
const { connector } = useGlobalConfigsStore();
const isLoading = ref(true);
const url = ref<string | ArrayBuffer | null>("");
const hideQR = ref<boolean>(false);
const countDown = ref<number>(0);

const { t } = useTranslation();
const handleEnd = () => {
  hideQR.value = true;
  countDown.value = 0;
};
const handleLoad = () => {
  isLoading.value = false;
  countDown.value = 10 * 60;
  hideQR.value = false;
};
const getImage = async () => {
  const path = "/api/create-totp-code" + "?session=" + connector?.remoteControl.sessionID;

  const config = {
    url: path,
    method: "POST",
    responseType: "blob",
  };
  await axios(config as AxiosRequestConfig)
    .then((response) => {
      const reader = new FileReader();
      reader.readAsDataURL(response.data);
      reader.onload = () => {
        url.value = reader.result;
      };
    })
    .catch((err) => {
      console.error(err);
    });
};
onMounted(async () => {
  try {
    await getImage();
  } catch (error) {
    console.error("Error fetching the QR Code:", error);
  }
});
</script>
